import { useQuery } from '@tanstack/react-query'
import { checkDuplicatePlanAndRateOverrideRule } from '../../../api/plan-and-rate-override-rules-api'
import type { CheckDuplicatePlanAndRateOverrideRuleQueryDto } from '../../../api/dto/plan-and-rate-override-rules.dto'

export const PLAN_AND_RATE_OVERRIDE_CHECK_DUPLICATE_QUERY_KEY =
  'planAndRateOverrideCheckDuplicate'

export function useCheckDuplicatePlanAndRateOverrideRule(
  query: Partial<CheckDuplicatePlanAndRateOverrideRuleQueryDto>
) {
  return useQuery({
    queryKey: [PLAN_AND_RATE_OVERRIDE_CHECK_DUPLICATE_QUERY_KEY, query],
    queryFn: () =>
      checkDuplicatePlanAndRateOverrideRule(
        query as CheckDuplicatePlanAndRateOverrideRuleQueryDto
      ),
    enabled: !!(query.year && query.state && query.hiosPlanId),
    staleTime: 10_000,
  })
}
